export const DEFAULT_PROVIDER_ID = 'openai';

export const DEFAULT_MODEL_ID = 'gpt';

export const AI_PROVIDERS = [
  {
    id: 'openai',
    name: 'OpenAI',
    models: [
      {
        id: 'gpt',
        name: 'ChatGPT',
      },
    ],
  },
  {
    id: 'google',
    name: 'Google',
    models: [
      {
        id: 'gemini',
        name: 'Gemini',
      },
    ],
  },
  {
    id: 'deepseek',
    name: 'DeepSeek',
    models: [
      {
        id: 'deepseek',
        name: 'DeepSeek',
      },
    ],
  },
  {
    id: 'anthropic',
    name: 'Anthropic',
    models: [
      {
        id: 'claude',
        name: 'Claude',
      },
    ],
  },
];
